export default "__VITE_ASSET__CKjxBifc__"